import { Button, Card, Radio } from "antd"
import SearchField from "components/timenotes/fields/filters/search-field"
import { FormikProvider } from "formik"
import RadioGroupField from "components/timenotes/fields/radio-group-field"
import TeamFilterField from "components/timenotes/fields/filters/team-filter-field"
import TagsFilterField from "components/timenotes/fields/filters/tags-filter-field"
import useTasksFiltersFormik from "@timenotes/shared/src/services/tasks/hooks/use-tasks-filters-formik"
import BillableSelectField from "components/timenotes/fields/filters/billable-select-field"
import GenericButtonsList, { TGenericButton } from "components/generic-buttons-list/generic-buttons-list"
import { ArchiveSvg, MoreSvg } from "assets/svg/icon"

interface TaskFilterProps {
  tasksFiltersFormik: ReturnType<typeof useTasksFiltersFormik>
  canSetTimeLogBillable?: boolean
  projectId?: string
}

export function TaskFilter(props: TaskFilterProps) {
  const {
    projectId
  } = props

  const teamFilterFilters = projectId ? { projectId } : undefined
  const formik = props.tasksFiltersFormik
  const canSetTimeLogBillable = (props.canSetTimeLogBillable === undefined) ? false : props.canSetTimeLogBillable

  const displayArchivedSections = formik.values.sectionStatus == 'all'

  const options: TGenericButton[] = [
    {
      title: '',
      icon: MoreSvg,
      type: 'text',
      options: [
        {
          title: "Display archived sections",
          Icon: ArchiveSvg,
          callback: () => formik.setFieldValue('sectionStatus', 'all')
        }
      ]
    }
  ]

  return (
    <Card>
      <div
        style={{
          display: "flex",
          width: '100%',
          justifyContent: "flex-start",
          alignItems: "center",
          gap: ".5rem",
        }}
      >
        <FormikProvider value={formik}>
          <SearchField
            placeholder="Filter tasks by name"
            name="name"
            style={{ width: '20%' }}
          />

          <RadioGroupField
            name="state"
            placeholderValue="all"
          >
            <Radio.Button value={"all"}> All </Radio.Button>
            <Radio.Button value={"active"}> Active </Radio.Button>
            <Radio.Button value={"archived"}> Archived</Radio.Button>
          </RadioGroupField>

          {canSetTimeLogBillable && (
            <BillableSelectField
              name="isBillable"
            />
          )}

          <TeamFilterField
            filters={teamFilterFilters}
            membersKey="users"
            groupsKey="groups"
            noMemberOption={{
              resourceKey: 'member#no_assignee',
              id: 'no_assignee',
              name: 'No assignee',
            }}
          />

          <TagsFilterField
            name="tagIds"
          />

        { displayArchivedSections && (
          <Button
            type="default"
            onClick={() => { formik.setFieldValue('sectionStatus', 'active') }}
          >
            Χ Display archived sections
          </Button>
        )}

        </FormikProvider>

        {formik.dirty && (
          <Button
            type="text"
            onClick={() => formik.resetForm()}
            style={{
              color: "gray"
            }}>
            Χ Clear filters
          </Button>
        )}


        <div
          style={{
            marginLeft: 'auto',
          }}
        >
          {!displayArchivedSections && (
            <GenericButtonsList buttons={options} />
          )}
        </div>
      </div>

    </Card>
  )
}
